import {Grid} from "@material-ui/core"
import MaterialTable from "@material-table/core"
import * as React from "react"
import {MainAPI} from "../core/api/FApi"
import {t} from "../core/lang/lang"
import {useParams} from "react-router"
import {connect} from "react-redux";

const TOIRPage = (props) => {
    let {devid} = useParams<Record<string, string | undefined>>()
    const [columns, setColumns] = React.useState(null)

    //console.log("deviceId = " + devid)
    const hasWritePermission = props.userOptions?.perms?.includes("table_devices_rw")

    if (columns == null) {
        MainAPI.editorsGetFields("toir").then((data) => {
            setColumns(data.fields)
        }).catch(()=>{})
        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={1}/>
                    <Grid item xs={12}>
                        Loading...
                    </Grid>
                    <Grid item xs={1}/>
                </Grid>
            </>
        )
    } else
        return (
            <Grid container spacing={1}>
                <Grid item xs={1}/>
                <Grid item xs={12}>
                    <MaterialTable
                        title={t("TOIR")}
                        columns={columns}
                        options={{
                            search: false,
                            pageSize: 10, filtering: true
                        }}
                        data={(query) =>
                            MainAPI.toirList(query, devid).then((result) => {
                                return {
                                    data: result.result,
                                    page: query.page,
                                    totalCount: result.count,
                                }
                            })
                        }
                        icons={props.tableIcons}
                        editable={hasWritePermission ? {
                            onRowUpdate: (newData) => MainAPI.toirUpdate(newData),
                            onRowAdd: (newData) => MainAPI.toirCreate({...newData, device_id: Number(devid)}),
                            onRowDelete: (req: any) => MainAPI.toirDelete(req.id),
                        } : {}}
                    />
                </Grid>
                <Grid item xs={1}/>
            </Grid>
        )
}

const mapStateToProps = (state) => {
    return {
        userOptions: state.loadedOptions.userOptions,
    }
}

export default connect(mapStateToProps)(TOIRPage)